import React from "react";
import GovGrButton from "../../../../components/GovGrButton";
import { WARNING } from "../../../../components/GovGrButton/buttonConstants";
import GovGrModal from "../../../../components/GovGrModal";
import useLocale from "../../../../hooks/useLocale";

import { Formik } from "formik";
import { Grid, DialogActions, DialogContent } from "@material-ui/core";
import GovGrTextField from "../../../../components/GovGrTextField";
import { fetchPoinikoMitrooDoc } from "../../../../services/attachedDocuments";
import { useEffect } from "react";
import { useState } from "react";

const GatewayDataViewDetails = ({ open, close, data, applId }) => {
  const { t } = useLocale();
  const [mitrooButtonDisabled, setMitrooButtonDisabled] = useState(false);
  let dataTransformed = {};

  Object.entries(data).forEach(([key, value]) => {
    if (!["id", "dscr", "tableData"].includes(key)) {
      dataTransformed = {
        ...dataTransformed,
        ...Object.fromEntries([[key, value]]),
      };
    }
  });

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchPoinikoMitrooDoc(applId);
        if (res?.doc_data) {
          setMitrooButtonDisabled(false);
        } else {
          setMitrooButtonDisabled(true);
        }
      } catch (e) {
        setMitrooButtonDisabled(true);
      }
    })();
  }, []);

  const initialValues = dataTransformed;
  return (
    <GovGrModal onClose={close} open={open} customContent={true}>
      <div className="h-full">
        <h1 className="govgr-heading-l">Δεδομένα για {t(`${data?.dscr}`)}</h1>
        <DialogContent>
          <Formik initialValues={initialValues} enableReinitialize>
            <>
              <Grid container spacing={4}>
                {Object.keys(dataTransformed).map((item) => {
                  return (
                    <Grid item xs={6}>
                      <GovGrTextField
                        disabled
                        name={item}
                        label={t(`${item}`)}
                      />
                    </Grid>
                  );
                })}
                {Object.keys(data).some((entry) =>
                  entry.startsWith("criminal")
                ) && (
                    <Grid item xs={6}>
                      <GovGrButton
                        buttonText={t("View")}
                        disabled={mitrooButtonDisabled}
                        onClick={async () => {
                          try {
                            const res = await fetchPoinikoMitrooDoc(applId);
                            const blob = new Blob(
                              [new Uint8Array(res?.doc_data.data)],
                              {
                                type: res?.content_type,
                              }
                            );
                            if (navigator.userAgent.match(/firefox|fxios/i)) {
                              // console.log("view file");
                              // console.log(blob);
                              let url = window.URL.createObjectURL(blob);
                              // console.log(url);
                              window.open(url, "_blank");
                            } else {
                              let url = window.URL.createObjectURL(blob);
                              window.open(url, "_blank");
                              // let a = document.createElement("a");
                              // a.href = url;
                              // // a.download = rowData?.file_name;
                              // a.click();
                            }
                          } catch (e) { }
                        }}
                      />
                    </Grid>
                  )}
              </Grid>
            </>
          </Formik>
        </DialogContent>
        <DialogActions>
          <GovGrButton
            buttonText={t("Close")}
            onClick={close}
            variant={WARNING}
          />
        </DialogActions>
      </div>
    </GovGrModal>
  );
};

export default GatewayDataViewDetails;
